export default __webpack_public_path__ + "static/media/cog-green.1cba65d8.svg";